export default function GameBoard({ shape }) {
  if (!shape) return null;

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100">

      {/* Rectangle */}
      {shape.type === "rectangle" && (
        <div className="w-40 h-24 bg-red-500 rounded-md" />
      )}

      {/* Circle */}
      {shape.type === "circle" && (
        <div className="w-32 h-32 bg-green-500 rounded-full" />
      )}

      {/* Triangle */}
      {shape.type === "triangle" && (
        <div className="w-0 h-0 border-l-[60px] border-l-transparent border-r-[60px] border-r-transparent border-b-[100px] border-b-blue-500" />
      )}

    </div>
  );
}
